import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0B1A]">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center text-blue-400 hover:text-blue-300 transition-colors mb-8"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Home
        </Link>

        <h1 className="text-3xl font-bold text-white mb-8">Terms of Service</h1>
        
        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Agreement to Terms</h2>
            <p className="mb-4">
              By accessing or using UnifyAds, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing UnifyAds.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Use License</h2>
            <div className="space-y-4">
              <p>Permission is granted to temporarily access UnifyAds for personal or business use, subject to the following conditions:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>You must not modify or copy the materials</li>
                <li>You must not use the materials for any commercial purpose without proper licensing</li>
                <li>You must not attempt to reverse engineer any software contained in UnifyAds</li>
                <li>You must not remove any copyright or proprietary notations</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Account Terms</h2>
            <div className="space-y-4">
              <h3 className="text-lg font-medium text-white">3.1 Account Creation</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>You must provide accurate and complete information</li>
                <li>You are responsible for maintaining account security</li>
                <li>You must notify us of any security breaches</li>
                <li>You must be 16 years or older to use our services</li>
              </ul>

              <h3 className="text-lg font-medium text-white">3.2 Account Termination</h3>
              <p>We reserve the right to terminate accounts for:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Violation of these terms</li>
                <li>Fraudulent or illegal activities</li>
                <li>Non-payment of fees</li>
                <li>Extended periods of inactivity</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Service Terms</h2>
            <div className="space-y-4">
              <h3 className="text-lg font-medium text-white">4.1 Service Availability</h3>
              <p>
                We strive to maintain 99.9% uptime but cannot guarantee uninterrupted access to our services. We reserve the right to modify, suspend, or discontinue any part of our services with or without notice.
              </p>

              <h3 className="text-lg font-medium text-white">4.2 API Usage</h3>
              <p>
                Use of our API is subject to rate limits and fair usage policies. Excessive or abusive usage may result in temporary or permanent suspension of access.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">5. Payment Terms</h2>
            <div className="space-y-4">
              <p>By subscribing to our paid services:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>You agree to pay all fees in accordance with the pricing plan selected</li>
                <li>Subscription fees are billed in advance on a monthly or annual basis</li>
                <li>No refunds will be issued for partial use of services</li>
                <li>We reserve the right to change pricing with 30 days notice</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">6. Data Usage and Privacy</h2>
            <p className="mb-4">
              Your use of UnifyAds is also governed by our Privacy Policy. By using our services, you consent to the collection and use of information as detailed in our Privacy Policy.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">7. Intellectual Property</h2>
            <div className="space-y-4">
              <p>
                UnifyAds and its original content, features, and functionality are owned by us and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">8. Limitation of Liability</h2>
            <div className="space-y-4">
              <p>
                UnifyAds shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the service.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">9. Third-Party Services</h2>
            <div className="space-y-4">
              <p>
                Our platform integrates with various third-party services. We are not responsible for any third-party services, and your use of such services is governed by their respective terms of service.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">10. Changes to Terms</h2>
            <p className="mb-4">
              We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through our platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">11. Contact Information</h2>
            <p className="mb-4">
              For questions about these Terms of Service, please contact us at:
            </p>
            <div className="bg-[#151632]/50 backdrop-blur-sm p-6 rounded-xl border border-[#1E2048]">
              <p>Email: info@unifyads.io</p>
            </div>
          </section>

          <section className="pt-8">
            <p className="text-sm text-gray-400">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;